import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Ellipsis } from '@elo-kit/components/ellipsis/Ellipsis'
import { FILE_NAME_MAX_LEN } from '../constants/constants'

export const FileName = React.memo(({ fileName, classes }) => (
  <div title={fileName} className={classNames('filename-container', classes.filenameContainer)}>
    <Ellipsis maxLength={FILE_NAME_MAX_LEN}>{fileName}</Ellipsis>
  </div>
))

FileName.propTypes = {
  fileName: PropTypes.string,
  classes: PropTypes.object,
}

FileName.defaultProps = {
  fileName: '',
  classes: {},
}
